/**
 * Shell route-transition key.
 *
 * Inbox/Contacts keep per-path keys. Campaigns, Reports, and Settings keep a
 * workspace key so entering the workspace uses the same fade as Inbox, while
 * internal tab/pane motion is not stacked on a second shell animation.
 */
export function routeTransitionKey(pathname: string): string {
  if (pathname === "/reports" || pathname.startsWith("/reports/")) {
    return "/reports";
  }
  if (pathname === "/campaigns" || pathname.startsWith("/campaigns/")) {
    return "/campaigns";
  }
  if (pathname === "/settings" || pathname.startsWith("/settings/")) {
    return "/settings";
  }
  if (pathname === "/channels" || pathname.startsWith("/channels/")) {
    return "/channels";
  }
  return pathname;
}
